// @flow
import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import type { Node } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';

const useStyles = makeStyles({
    root: {
        minWidth: 250
    }
});

type Props = $ReadOnly<{
    type: 'text' | 'number',
    label: Node,
    path: $ReadOnlyArray<string>,
    value: boolean,
    defaultValue?: string | number,
    placeholder?: string,
    prepend?: Node,
    append?: Node,
    disabled?: boolean,
    className?: string,

    onChange: (path: $ReadOnlyArray<string>, value: boolean) => void,
    inputFormatter?: (value: any) => number | string
}>;

function Text({ type, label, path, value, defaultValue, placeholder, prepend, append, disabled, className, onChange, inputFormatter }: Props) {
    const classes = useStyles();
    const [innerValue, setInnerValue] = useState(typeof value !== 'undefined' && inputFormatter ? inputFormatter(value) : value);

    useEffect(() => setInnerValue(typeof value !== 'undefined' && inputFormatter ? inputFormatter(value) : value), [value, inputFormatter]);

    const handleChange = (e) => setInnerValue(e.target.value);
    const handleBlur = () => onChange(path, type === 'number' ? parseInt(innerValue, 10) : innerValue);

    return (
        <TextField
            className={classnames(classes.root, className)}
            label={label}
            margin="dense"
            variant="filled"
            value={typeof innerValue !== 'undefined' ? innerValue : ( (typeof defaultValue !== 'undefined' && inputFormatter ? inputFormatter(defaultValue) : defaultValue ) || '')}
            placeholder={placeholder}
            InputProps={{
                startAdornment: prepend && <InputAdornment position="start">{prepend}</InputAdornment>,
                endAdornment: append && <InputAdornment position="end">{append}</InputAdornment>
            }}
            disabled={disabled}
            fullWidth
            onChange={handleChange}
            onBlur={handleBlur}
        />
    );
}

export default Text;